import styled from 'styled-components'
import Section from './Section'
import media from 'css-in-js-media'
import { Col } from 'react-styled-flexboxgrid'
import { X2CopySection } from './X2Copy'
import { Variables } from '../styles/Variables'
import Container from './Container'

export const X2HeadingSection = styled(Section)`
    display: flex;    
    margin: 0;
    padding: 76px 172px 133px 172px;

    ${media('<desktop')} {
        padding: 40px 20px;
        flex-direction: column;
    }

    ${Container} {
        padding: 0;
    }

    ${Col}:first-child {
        ${media('>=desktop')} {
            /* padding: 0px 0px 0px 5.6vw; */
        }
    }

    ${Col}:not(:last-child) {
        ${media('<desktop')} {
            padding-bottom: 25px;
        }
    }

    ${Col}:last-child {        
        ${media('>=desktop')} {
            padding-left: 102px;
        }
    }
`
